var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8b5cf6",
    d: "M56.8,-59.2C72.4,-45.4,83.3,-22.7,80.5,-3.5C77.6,15.8,61.1,31.6,45.6,46.6C30,61.5,15,75.6,-2.4,78.6C-19.7,81.6,-39.3,73.4,-53.5,59C-67.7,44.7,-76.4,24.3,-76.8,4.3C-77.2,-15.7,-69.3,-35.4,-55.4,-49.6C-41.4,-63.9,-20.7,-72.7,0.9,-73.5C22.5,-74.3,45.1,-67.1,56.8,-59.2Z",
    transform: "translate(100 100)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.841d3785e2b97706f945a81d1fa4a7c3.svg";
export { ForwardRef as ReactComponent };